export class StorageFasting {
  constructor() {
    this.STORAGE_NAME = "com.jamsolattv.atista.my.fasting.";
    this.KEY_STATE_ID = this.STORAGE_NAME + "state_id";
    this.KEY_STATE = this.STORAGE_NAME + "state";
    this.KEY_TOWN = this.STORAGE_NAME + "town";
    this.KEY_CODE = this.STORAGE_NAME + "code";
  }

  setStateId(value) {
    localStorage.setItem(this.KEY_STATE_ID, value);
  }
  getStateId() {
    return localStorage.getItem(this.KEY_STATE_ID);
  }

  setState(value) {
    localStorage.setItem(this.KEY_STATE, value);
  }
  getState() {
    return localStorage.getItem(this.KEY_STATE);
  }

  setTown(value) {
    localStorage.setItem(this.KEY_TOWN, value);
  }
  getTown() {
    return localStorage.getItem(this.KEY_TOWN);
  }

  setCode(value) {
    localStorage.setItem(this.KEY_CODE, value);
  }
  getCode() {
    return localStorage.getItem(this.KEY_CODE);
  }
}
